"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function GoogleChrome24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11Zm.597-6.035-2.243 3.885C6.17 20.077 3 16.408 3 12c0-1.138.211-2.227.597-3.23l4.384 6.208.001-.001a4.993 4.993 0 0 0 4.615 1.988Zm-5.356-6.502A5.002 5.002 0 0 1 12 7h7.485A8.992 8.992 0 0 0 12 3a8.989 8.989 0 0 0-7.346 3.8l2.587 3.663ZM21 12a9 9 0 0 1-8.412 8.981l3.689-6.39c.038-.062.075-.126.11-.191l.001-.002c.39-.712.612-1.529.612-2.398a4.978 4.978 0 0 0-1-3h4.488c.332.938.512 1.948.512 3Zm-6 0c0 .52-.132 1.008-.364 1.434l-.073.127A3 3 0 1 1 15 12Z", clipRule: "evenodd" }));
}
function GoogleChrome24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(GoogleChrome24Svg, Object.assign({}, svgProps)));
}
exports.default = GoogleChrome24;
//# sourceMappingURL=GoogleChrome24.js.map